"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultContext = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _v = _interopRequireDefault(require("uuid/v4"));
var createUuidGenerator = function createUuidGenerator(_ref) {
  var _ref$prefix = _ref.prefix,
    prefix = _ref$prefix === void 0 ? 'nw-aria' : _ref$prefix;
  return function generateRandomId() {
    return "".concat(prefix, "-").concat((0, _v.default)());
  };
};
var defaultContext = createUuidGenerator({});
exports.defaultContext = defaultContext;
var IdContext = /*#__PURE__*/_react.default.createContext(createUuidGenerator({}));
var _default = IdContext;
exports.default = _default;